import script from "./GuardianStudents.vue?vue&type=script&setup=true&lang=js"
export * from "./GuardianStudents.vue?vue&type=script&setup=true&lang=js"

import "./GuardianStudents.vue?vue&type=style&index=0&id=824a9f38&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-824a9f38"]])

export default __exports__